import * as AccountResources from '../../constants/accountResourceNames';

/**
 * @param {string} countryCode
 * @param {number|null} accountResourceId
 * @param {number|null} gamblerId
 * @returns {boolean}
 */
 export function isAvailableGames(countryCode, accountResourceId, gamblerId) {
  if (gamblerId === 75514727) return true; // DEMO ACCOUNT 276502
  if (gamblerId) {
    return (
      (accountResourceId === AccountResources.KG && countryCode === "KG") ||
      (accountResourceId === AccountResources.UZ && countryCode === "UZ")
    );
  }
  return countryCode === "KG" || countryCode === "UZ";
}

/**
 * @param {string} countryCode
 * @returns {object}
 */
export function getInitialCountryCode (countryCode){
  switch (countryCode) {
      case 'KZ':
          return {
              defaultCountryId: 79,
              accountResourceId: AccountResources.KZ,  
          }
      case 'UZ':
          return {
              defaultCountryId: 192,
              accountResourceId: AccountResources.UZ,  
          }
      default:
          return {
              defaultCountryId: 96,
              accountResourceId: AccountResources.KG,  
          }
  }
}


// WEBPACK FOOTER //
// ./js/shared/utils/functions.js